export const API_PATHS = {
    HEALTH: 'health',
    INVITES: 'invites',
    USERS: {
        BASE: 'users',
        SETTINGS: 'settings',
        ORGANIZATIONS: 'organizations',
        CHECK_PHONE: 'check-phone',
        CHECK_EMAIL: 'check-email',
    },
    ADMIN: {
        USERS: 'admin/users',
        INVITES: 'admin/invites',
        ORGANIZATIONS: 'admin/organizations',
        ROLES: 'admin/roles',
        APPLICATIONS: 'admin/applications',
    },
    ORGANIZATION: {
        BASE: 'organizations',
        USERS: 'users',
        INVITES: 'invites',
    },
};
